import { ItemList } from '../orm'

class MessageRecipientList extends ItemList {
    getEntityKey() {
        return 'message_recipient'
    }
}

export const messageRecipientList = new MessageRecipientList('message_recipient')
